import React, { useState, useEffect } from 'react';
import style from '../../css/Recharge.module.css'
function Menu({ onLinkClick }) {
    const [activeLink, setActiveLink] = useState("Thanh Toán Trực Tuyến");


    const handleLinkClick = (link) => {
        setActiveLink(link);
        onLinkClick(link); // Gọi hàm từ component cha khi người dùng click
    };
    return (
        // <div className="row">
        //     <div className="col-6">
        //         <div className="d-flex">
        //             <div className="nav flex-row" style={{ color: '' }}>
        //                 <a
        //                     className={
        //                         `${style.customlinkmenu} nav-link ${activeLink === "Thanh Toán Trực Tuyến" ? style.active : ""} `}
        //                     onClick={() => handleLinkClick("Thanh Toán Trực Tuyến")}


        //                 >Thanh Toán Trực Tuyến
        //                 </a>
        //                 <a
        //                     className={`${style.customlinkmenu} nav-link ${activeLink === "Lịch Sử Nạp Tiền" ? style.active : ""} `}
        //                     onClick={() => handleLinkClick("Lịch Sử Nạp Tiền")}

        //                 >Lịch Sử Nạp Tiền</a>
        //             </div>
        //         </div>

        //     </div>
        // </div>>
        <></>
    );
}

export default Menu;